import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL, HTTP_STATUS } from '../../utils/constant'
import { newAxiosInstance } from '../../../axios'

const initialState = {
    unpostedAdvances: [],
    unpostedLoans:    [],
    payrollBatches:   [],
    fetchStatus: HTTP_STATUS.IDLE,
    postStatus:  HTTP_STATUS.IDLE,
}

export const fetchUnpostedAdvances = createAsyncThunk('subLedger/advances/unposted', async ({ cutoffDate }, { rejectWithValue }) => {
    try {
        const res = await newAxiosInstance.get(BASE_URL + `/api/SubLedger/advances/unposted?cutoffDate=${cutoffDate}`)
        return res.data
    } catch(err) {
        if(!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
})

export const fetchUnpostedLoans = createAsyncThunk('subLedger/loans/unposted', async ({ cutoffDate }, { rejectWithValue }) => {
    try {
        const res = await newAxiosInstance.get(BASE_URL + `/api/SubLedger/loans/unposted?cutoffDate=${cutoffDate}`)
        return res.data
    } catch(err) {
        if(!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
})

export const fetchPayrollBatches = createAsyncThunk('subLedger/payroll/batches', async ({ cutoffDate }, { rejectWithValue }) => {
    try {
        const res = await newAxiosInstance.get(BASE_URL + `/api/SubLedger/payroll/batches?cutoffDate=${cutoffDate}`)
        return res.data
    } catch(err) {
        if(!err.response) throw err;
        return rejectWithValue(err.response.data)
    }
})

export const batchPostAdvances = createAsyncThunk('subLedger/advances/batch-post', async (body, { rejectWithValue }) => {
    try {
        const res = await newAxiosInstance.post(BASE_URL + '/api/SubLedger/advances/batch-post', body)
        return res.data
    } catch(err) {
        if(!err.response) throw err;
        return rejectWithValue(err.response)
    }
})

export const batchPostLoans = createAsyncThunk('subLedger/loans/batch-post', async (body, { rejectWithValue }) => {
    try {
        const res = await newAxiosInstance.post(BASE_URL + '/api/SubLedger/loans/batch-post', body)
        return res.data
    } catch(err) {
        if(!err.response) throw err;
        return rejectWithValue(err.response)
    }
})

export const batchPostPayroll = createAsyncThunk('subLedger/payroll/batch-post', async (body, { rejectWithValue }) => {
    try {
        const res = await newAxiosInstance.post(BASE_URL + '/api/SubLedger/payroll/batch-post', body)
        return res.data
    } catch(err) {
        if(!err.response) throw err;
        return rejectWithValue(err.response)
    }
})

const SubLedger = createSlice({
    name: 'subLedger',
    initialState,
    reducers: {
        resetState: () => initialState,
    },
    extraReducers(builder) {
        builder
            .addCase(fetchUnpostedAdvances.pending, (state) => {
                state.fetchStatus = HTTP_STATUS.LOADING
            })
            .addCase(fetchUnpostedAdvances.fulfilled, (state, action) => {
                state.fetchStatus = HTTP_STATUS.SUCCEEDED
                state.unpostedAdvances = action.payload
            })
            .addCase(fetchUnpostedAdvances.rejected, (state) => {
                state.fetchStatus = HTTP_STATUS.FAILED
            })
            .addCase(fetchUnpostedLoans.pending, (state) => {
                state.fetchStatus = HTTP_STATUS.LOADING
            })
            .addCase(fetchUnpostedLoans.fulfilled, (state, action) => {
                state.fetchStatus = HTTP_STATUS.SUCCEEDED
                state.unpostedLoans = action.payload
            })
            .addCase(fetchUnpostedLoans.rejected, (state) => {
                state.fetchStatus = HTTP_STATUS.FAILED
            })
            .addCase(fetchPayrollBatches.pending, (state) => {
                state.fetchStatus = HTTP_STATUS.LOADING
            })
            .addCase(fetchPayrollBatches.fulfilled, (state, action) => {
                state.fetchStatus = HTTP_STATUS.SUCCEEDED
                state.payrollBatches = action.payload
            })
            .addCase(fetchPayrollBatches.rejected, (state) => {
                state.fetchStatus = HTTP_STATUS.FAILED
            })
            .addCase(batchPostAdvances.pending, (state) => {
                state.postStatus = HTTP_STATUS.LOADING
            })
            .addCase(batchPostAdvances.fulfilled, (state) => {
                state.postStatus = HTTP_STATUS.SUCCEEDED
                state.unpostedAdvances = []
            })
            .addCase(batchPostAdvances.rejected, (state) => {
                state.postStatus = HTTP_STATUS.FAILED
            })
            .addCase(batchPostLoans.pending, (state) => {
                state.postStatus = HTTP_STATUS.LOADING
            })
            .addCase(batchPostLoans.fulfilled, (state) => {
                state.postStatus = HTTP_STATUS.SUCCEEDED
                state.unpostedLoans = []
            })
            .addCase(batchPostLoans.rejected, (state) => {
                state.postStatus = HTTP_STATUS.FAILED
            })
            .addCase(batchPostPayroll.pending, (state) => {
                state.postStatus = HTTP_STATUS.LOADING
            })
            .addCase(batchPostPayroll.fulfilled, (state, action) => {
                state.postStatus = HTTP_STATUS.SUCCEEDED
                const { year, month } = action.meta.arg
                const batch = state.payrollBatches.find(b => b.year === year && b.month === month)
                if (batch) batch.isPosted = true
            })
            .addCase(batchPostPayroll.rejected, (state) => {
                state.postStatus = HTTP_STATUS.FAILED
            })
    }
})

export const getUnpostedAdvances     = (state) => state.subLedger.unpostedAdvances;
export const getUnpostedLoans        = (state) => state.subLedger.unpostedLoans;
export const getPayrollBatches       = (state) => state.subLedger.payrollBatches;
export const getSubLedgerFetchStatus = (state) => state.subLedger.fetchStatus;
export const getSubLedgerPostStatus  = (state) => state.subLedger.postStatus;
export const subLedgerActions        = SubLedger.actions;

export default SubLedger.reducer;
